import KeycloakManager from "../keycloak";

const authHeaders = () => {
  const token = KeycloakManager.getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const fetchWithAuth = async (input: RequestInfo, init: RequestInit = {}) => {
  const headers = { ...(init.headers || {}), ...authHeaders() };
  const resp = await fetch(input, { ...init, headers });
  return resp;
};

export const safeJson = async (response: Response) => {
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Fetch failed ${response.status}: ${text}`);
  }
  return response.json();
};

export const buildUrl = (base: string, params: Record<string, any>) => {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") {
      usp.set(k, String(v));
    }
  });
  const query = usp.toString();
  return query ? `${base}?${query}` : base;
};
